import React, { useState } from "react";
import Header from "../../../Components/Header";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import ServiceRequest from "./ServiceRequest";
import NewUpload from "./NewUpload";
import DraftMain from "./DraftMain";

function OffMarketTabs(props) {

     const [activeTab, setActiveTab] = useState("admin");

    return (
        <div className="off-market-main">
            <Header title={props.title} portal={""} />
            <SingleSignOnSideBar />
            <main id="offmarket-main-content">
                <div className="tab-content card-box off-market-tab" id="mainTabContent">
                    <div
                        className="tab-pane fade show active"
                        id="team"
                        role="tabpanel"
                        aria-labelledby="team-tab"
                    >
                        <div className="secondary-tabs">
                            <div className="card-tab-list">
                                <ul className="nav page-tabs" id="mainTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === "admin" ? "active" : ""}`}
                                            id="admin-tab"
                                            data-toggle="tab"
                                            data-target="#admin"
                                            type="button"
                                            role="tab"
                                            aria-controls="admin"
                                            aria-selected="true"
                                            onClick={() => setActiveTab("admin")}
                                        >
                                            New Upload
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation"  >
                                        <button
                                            className={`nav-link ${activeTab === "srRequest" ? "active" : ""}`}
                                            id="srRequest-tab"
                                            data-toggle="tab"
                                            data-target="#srRequest"
                                            type="button"
                                            role="tab"
                                            aria-controls="srRequest"
                                            aria-selected="false"
                                            onClick={() => setActiveTab("srRequest")}
                                        >
                                            Service Requests
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${activeTab === "drafttab" ? "active" : ""}`}
                                            id="drafttab-tab"
                                            data-toggle="tab"
                                            data-target="#drafttab"
                                            type="button"
                                            role="tab"
                                            aria-controls="drafttab"
                                            aria-selected="false"
                                            onClick={() => setActiveTab("drafttab")}
                                        >
                                            Drafts
                                        </button>
                                    </li>
                                </ul>
                            </div>

                            <div className="card-tab-details">
                                <div
                                    className="tab-content dashboard-tab-content"
                                    id="nav-tabContent"
                                >
                                        {activeTab === "admin" && (
                                        <NewUpload setActiveTab={setActiveTab} />
                                        )}
                                        {activeTab === "srRequest" && (
                                            <ServiceRequest />
                                        )}
                                         {activeTab === "drafttab" && (
                                            <DraftMain setActiveTab={setActiveTab} />
                                         )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default OffMarketTabs;
